import styled from 'styled-components';

export const TickerSymbol = styled('b')`
  margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
  color: ${({ theme }) => theme.color.brand01};
`;

export const Detail = styled('td')`
  a {
    white-space: normal;
  }
`;

export const Name = styled('td')`
  span {
    ${({ theme }) => theme.typography.tiny}
  }
  a {
    max-width: 180px;
  }
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  line-height: 1 !important;
  border: none !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SharePrice = styled('span')`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
`;

export const NoData = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)} !important;
  text-align: center;
  background: transparent;
  cursor: auto !important;
  min-height: ${({ theme }) => theme.x5spacePx}px;
`;
